<template>
    <div class="TQ_center TQ_bg_white TQ_maxWidth_750px"
         :key="currentMissionRiddleId_n"
         v-if="server_questBody_c && server_currentUserData_c && server_teamStatus_c">


        <tq-riddle-data
                :p_name_s="currentMissionRiddleId_n + ''"

                :p_system_lang-code_e="store_system_langCode_ve.val"
                :p_qb_display-lang-code_e="co_getDisplayLangCode_e"

                :p_team-status_sub-collection_e="enum_subCollection_teamStatus.LIST_MISSIONS"

                :p_user-id_uid="server_currentUserData_c.ud_userId_uid"
                :p_window-size_e="store_system_windowSizeType_ve.val"

                :p_qb_riddle_c="co_getCurrentMissionRiddle_c"

                :p_riddle-status_c="server_ts_listMissions_byRiddleId_c[currentMissionRiddleId_n]"

                :p_clues-left_n="server_teamStatus_c.ts_cluesLeft_n"
                :p_skips-left_n="server_teamStatus_c.ts_skipsLeft_n"

                :p_current-user-location_c="null"

                :p_display-riddle-image_b="true"
                :p_qb_metadata_c="server_questBody_c.qb_metadata_c"

                :p_click-get-clue_f="m_clickGetClue_f"
                :p_click-skip-riddle_f="m_skipLock_f"
                :pe_rs_unlock-data_update_f="m_unlockLock_f"
                :pe_click-image_f="m_clickImg_f"

                :pe_start-watch-position_f="pe_startWatchPosition_f"
                :pe_stop-watch-position_f="pe_stopWatchPosition_f"

        />

    </div>
    <div v-else class="TQ_center">
        <ball-pulse-sync-loader color="#2E294E" size="10px"></ball-pulse-sync-loader>
    </div>

</template>

<script>
    import TqCard from "../../../components/basic/TqCard";
    import {enum_finishQuest_s, enum_subCollection_teamStatus} from "../../../../functions/src/shareCode/Share_S_Enum";
    import {
        serverOngoing_teamStatus_subCollection_cl_get_f,
        serverOngoing_teamStatus_subCollection_cl_remove_f,
        serverOngoing_teamStatusSub_riddleStatus_unlockData_update_f,
        serverOngoing_teamStatus_riddleStatus_useClue_update_f,
        serverOngoing_teamStatus_vl_set_f,
        serverOngoing_teamStatus_vl_remove_f,
        serverOngoing_teamStatusSub_riddleStatus_useSkip_f,
    } from "../../../scripts/Server/S_ServerOngoing";
    import {store_var, store_getStateValue_vo, store_setStateValue} from "../../../store";
    import {
        serverAuth_currentUserData_remove_vl_f
    } from "../../../scripts/Server/S_ServerAuth";
    import TqRiddleData from "../../../components/complex/TqRiddleData";
    import {serverBig_questBody_once_fp} from "../../../scripts/Server/S_ServerFirestore";
    import {route_getUrlParams} from "../../../router";
    import {
        enum_urlParams
    } from "../../../../functions/src/shareCode/Share_S_Enum";
    import {serverAuth_currentUserData_get_vl_fp} from "../../../scripts/Server/S_ServerAuth";
    import {
        helper_finishAllRiddle_fb,
        helper_finishRiddle_fb,
        helper_totalFinishRiddleNum_fn
    } from "../../../scripts/S_Helper";

    export default
    {
        name: "V_Ongoing_Mission_Item",
        components: {TqRiddleData, TqCard},
        props:{
            pe_startWatchPosition_f:{
                type: Function,
                require: true
            },
            pe_stopWatchPosition_f:{
                type: Function,
                require: true
            }
        },
        data(){
            return {

                // local
                changeFileIndex         : null,
                currentPlayerTeamId_uid : null,
                currentMissionRiddleId_n : null,

                // store
                store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),
                store_questEvent_c       : store_getStateValue_vo(store_var.ongoing_questEvent).val,
                store_currentTeamId_uid  : store_getStateValue_vo(store_var.ongoing_currentTeamId_uid).val,
                store_system_windowSizeType_ve  : store_getStateValue_vo(store_var.system_windowSizeType_e),

                // server
                server_questBody_c                      : undefined,
                server_ts_listMissions_byRiddleId_c  : {},
                server_currentUserData_c                : undefined,
                server_teamStatus_c                     : undefined,

                enum_subCollection_teamStatus : enum_subCollection_teamStatus,

            }
        },
        computed:{

            co_getCurrentMissionRiddle_c(){

                for(let i=0; i< this.server_questBody_c.qb_listMissions_ac.length; i++){
                    let missionRiddle = this.server_questBody_c.qb_listMissions_ac[i]
                    if(missionRiddle.qbr_riddleId_n === this.currentMissionRiddleId_n){
                        return missionRiddle
                    }
                }
                return null
            },
            co_getDisplayLangCode_e() {
                return this.server_questBody_c.cm_qb_getDisplayLangCode_e(this.store_system_langCode_ve.val)
            },
            co_currentLastRiddle_b(){

                switch(this.server_questBody_c.qb_metadata_c.qbm_quest_finishQuest_e){

                    case enum_finishQuest_s.listMissions_last:
                        return this.server_questBody_c.qb_listMissions_ac[this.server_questBody_c.qb_listMissions_ac.length-1].qbr_riddleId_n === this.currentMissionRiddleId_n
                    case enum_finishQuest_s.listMissions_all:
                        return helper_totalFinishRiddleNum_fn(this.server_questBody_c.qb_listMissions_ac, this.server_ts_listMissions_byRiddleId_c) + 1 === this.server_questBody_c.qb_listMissions_ac.length
                }

            }

        },
        methods:{

            m_clickImg_f(imgSrc_s){
                store_setStateValue(store_var.ongoing_fullScreenImage_s, imgSrc_s)
            },

            m_skipLock_f(unlocksData_byLockId_c, cb_f){

                let lastRiddle_b = this.co_currentLastRiddle_b
                serverOngoing_teamStatusSub_riddleStatus_useSkip_f({
                    questEvent_c: this.store_questEvent_c,
                    teamId_uid: this.store_currentTeamId_uid,
                    userId_uid: this.server_currentUserData_c.ud_userId_uid,
                    teamStatus_subCollection_e: enum_subCollection_teamStatus.LIST_MISSIONS,
                    riddleId_n: this.currentMissionRiddleId_n,
                    unlocksData_byLockId: unlocksData_byLockId_c,

                    finishRiddle_fb : () => helper_finishRiddle_fb(this.co_getCurrentMissionRiddle_c, this.server_ts_listMissions_byRiddleId_c[this.currentMissionRiddleId_n]),
                    lastRiddle_fb   : () => lastRiddle_b,
                    cb_f : cb_f
                })
            },
            m_unlockLock_f(lockIndex_n, rs_unlocksData_c, cb_f){

                serverOngoing_teamStatusSub_riddleStatus_unlockData_update_f({
                    questEvent_c                : this.store_questEvent_c,
                    teamId_uid                  : this.store_currentTeamId_uid,
                    userId_uid                  : this.server_currentUserData_c.ud_userId_uid,
                    teamStatus_subCollection_e  : enum_subCollection_teamStatus.LIST_MISSIONS,

                    lockIndex_n                 : lockIndex_n,
                    rs_lockData_c               : rs_unlocksData_c,
                    questSupportPoints_b        : this.server_questBody_c.qb_metadata_c.qbm_missions_supportMissionsPoints_b,

                    riddleData_c                : this.co_getCurrentMissionRiddle_c,
                    questLastRiddle_b           : this.co_currentLastRiddle_b,
                    riddleStatus_c              : this.server_ts_listMissions_byRiddleId_c[this.currentMissionRiddleId_n],

                    cb_f : cb_f
                })
            },
            m_clickGetClue_f(clueIndex_n, cb_f) {

                serverOngoing_teamStatus_riddleStatus_useClue_update_f({
                    questEvent_c: this.store_questEvent_c,
                    teamId_uid  : this.store_currentTeamId_uid,
                    userId_uid  : this.server_currentUserData_c.ud_userId_uid,
                    teamStatus_subCollection_e: enum_subCollection_teamStatus.LIST_MISSIONS,

                    riddleData_c: this.co_getCurrentMissionRiddle_c,
                    teamStatus_c: this.server_teamStatus_c,

                    clueId_n    : clueIndex_n,
                    clueMode_e  : this.server_questBody_c.qb_metadata_c.qbm_missions_cluesMode_e,
                    cb_f        : cb_f
                })
            },

        },

        // life circle
        mounted(){
            this.currentMissionRiddleId_n = parseInt(route_getUrlParams(this.$route,enum_urlParams.missionRiddleId_n))

            // 1) current user data
            serverAuth_currentUserData_get_vl_fp(
                this.$options.name,
                (userData_c) => {
                    this.server_currentUserData_c = userData_c

                })

            // 2) teamStatus
            serverOngoing_teamStatus_vl_set_f({
                viewName_s: this.$options.name, 
                questEvent_c : this.store_questEvent_c, 
                teamId_uid : this.store_currentTeamId_uid,
                cb_f: (teamStatus_c) => {
                    this.server_teamStatus_c = teamStatus_c
                }
            })

            // 3) teamStatus subCollection missions riddles
            serverOngoing_teamStatus_subCollection_cl_get_f({
                viewName_s          : this.$options.name,
                subCollectionName_e : enum_subCollection_teamStatus.LIST_MISSIONS,
                questEvent_c        : this.store_questEvent_c,
                teamId_uid          : this.store_currentTeamId_uid,
                cb_ChildAdded_f : (riddleStatus_c) => {
                    this.$set(this.server_ts_listMissions_byRiddleId_c, riddleStatus_c.rs_riddleId_n, riddleStatus_c)
                },
            })

            // 3) get questBody
            serverBig_questBody_once_fp(this.store_questEvent_c.qev_questType_e, this.store_questEvent_c.qev_questId_uid, false, true, (questBody_c)=>{
                this.server_questBody_c = questBody_c
            })

        },
        activated(){
            this.currentMissionRiddleId_n = parseInt(route_getUrlParams(this.$route,enum_urlParams.missionRiddleId_n))
        },
        destroyed(){

            // 1) CURRENT USER DATA
            serverAuth_currentUserData_remove_vl_f(this.$options.name)

            // 2) team status
            serverOngoing_teamStatus_vl_remove_f(this.$options.name, this.store_questEvent_c, this.store_currentTeamId_uid)

            // 3) teamStatus subCollection missions riddles
            serverOngoing_teamStatus_subCollection_cl_remove_f({
                viewName_s          : this.$options.name,
                subCollectionName_e : enum_subCollection_teamStatus.LIST_MISSIONS,
                questEvent_c        : this.store_questEvent_c,
                teamId_uid          : this.store_currentTeamId_uid,
            })

        },
    }
</script>

<style scoped lang="scss">

    .chooseFileBtn{
        position: fixed;
        right: 16px;
        bottom: 62px;
        background: #885ead;
        background: var(--color-purple_lite);
    }

</style>